import { Clickable, Col, Row, Text } from 'components';
import { useOutsideClick } from 'core';
import { Api } from 'lib';
import React, { useRef, useState } from 'react';
import { IrreversableModal } from 'screens/Admin/components';
import { store } from 'store';
import styled from 'styled-components';

const Container = styled.div`
  width: 110px;
  background-color: #fff;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
  z-index: 0;
  margin: -20px 0 0 -40px;
  height: 20px;
  position: relative;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
`;

const Menu = ({ fancamId, visible, close, onDelete }) => {
  const containerRef = useRef(),
    [deleting, setDeleting] = useState(false),
    [showDeleteAlert, setShowDeleteAlert] = useState(false);

  useOutsideClick(containerRef, () => visible && !deleting && close(), [
    'confirm-action',
    'modal-bg',
    'modal-container',
    'modal-popup'
  ]);

  function wrapUp() {
    setShowDeleteAlert(false);
    setDeleting(false);
    close();
  }

  async function handleDelete() {
    setDeleting(true);
    const res = await Api.delete(`/admin/fancam/delete/${fancamId}`);
    setDeleting(false);
    if (res) {
      store.dispatch({ type: 'ADMIN_REMOVE_FANCAM', payload: fancamId });
      onDelete?.(fancamId);
    }
    wrapUp();
  }

  if (!visible) {
    return null;
  }

  return (
    <React.Fragment>
      <Container ref={containerRef} visible={!showDeleteAlert}>
        <Col>
          <Clickable onClick={() => setShowDeleteAlert(true)}>
            <Row noFlex ht="48px" bg="#fff" center>
              <Text med pad="0" marg="0 0 0 16px" col="#E53935">
                Delete
              </Text>
            </Row>
          </Clickable>
        </Col>
      </Container>
      <IrreversableModal
        visible={showDeleteAlert}
        onConfirm={handleDelete}
        closeModal={() => setShowDeleteAlert(false)}
        noOutsideClick={true}
        waiting={deleting}
        confirmText="Delete"
        heading="You are about to delete this fancam."
      />
    </React.Fragment>
  );
};

export default Menu;
